exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer[data-v-5c89521e]{background:#fff;border-top:1px solid #e3d6ca;max-width:580px;margin:48px auto 0}.footer .menuList[data-v-5c89521e]{padding:20px 48px 12px;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.footer .menuList .menu[data-v-5c89521e]{width:50%;font-size:12px;margin:8px 0}.footer .company[data-v-5c89521e]{background:#ffe546;font-size:12px;padding:14px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-decoration:none}.footer .company img[data-v-5c89521e]{margin-left:8px}.footer .inc[data-v-5c89521e]{font-size:14px;padding:18px;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5c89521e","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/ChounDiary/partials/FooterChoun.vue
// module id = j/Kg
// module chunks = 0